import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  button: {
    cursor: 'pointer'
  },
  text: {
    textTransform: 'uppercase'
  },
  arrow: {
    color: token.grey.grey1,
    fontSize: 16
  }
}))
